"use client";
import React, { createContext, useContext, useState } from "react";

export type GalleryCtxProps = {
  performances: any;
  setPerformances: (d: any | null) => void;
  winners: any;
  setWinners: (d: any | null) => void;
  carpets: any;
  setCarpets: (d: any | null) => void;
  currentGalleryItem: number;
  setCurrentGalleryItem: (d: number | null) => void;
  currentGalleryItems: any[];
  setCurrentGalleryItems: (d: any[] | null) => void;
  winnersInitialData: any;
};

export const GalleryContext = createContext<GalleryCtxProps>(
  {} as GalleryCtxProps,
);

export const useGalleryCtx = () => useContext(GalleryContext);

export function GalleryContextProvider({
  children,
  winnersInitialData,
}: {
  children: React.ReactNode;
  winnersInitialData?: any;
}) {
  const [currentGalleryItem, setCurrentGalleryItem] = useState<any>(null);
  const [performances, setPerformances] = useState<any>(Array(6).fill(0));
  const [winners, setWinners] = useState<any>(winnersInitialData ?? []);
  const [carpets, setCarpets] = useState<any>(Array(6).fill(0));
  const [currentGalleryItems, setCurrentGalleryItems] = useState<any>(null);

  return (
    <GalleryContext.Provider
      value={{
        performances,
        setPerformances,
        currentGalleryItem,
        setCurrentGalleryItem,
        winners,
        setWinners,
        carpets,
        setCarpets,
        currentGalleryItems,
        setCurrentGalleryItems,
        winnersInitialData,
      }}
    >
      {children}
    </GalleryContext.Provider>
  );
}
